import { priceBookEntryIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const deletePriceBookEntry = unaryRpc({
  name: "deletePriceBookEntry" as const,
  input: z.object({ entryId: priceBookEntryIdFormat.schema }),
  output: z.object({}),
});
